import { 
  useTheme, 
  useMediaQuery, 
  Box, 
} from "@mui/material";
import Form from "./Form";


const LoginPage = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Box 
      display="flex" 
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      aria-label="Login page"      
    >
      <Box
        width={isDesktop ? "50%" : "92%"}
        sx={{
          position: "relative",
          borderRadius: "1rem",
          padding: "1px", 
          background: `linear-gradient(
            150deg, 
            ${theme.palette.primary.main},
            ${theme.palette.primary.light},
            ${theme.palette.primary.main}
          )`,
          backgroundSize: "200% 200%",
          animation: "shine 6s linear infinite",
          "@keyframes shine": {
            "0%": { backgroundPosition: "0% 50%" },
            "100%": { backgroundPosition: "200% 50%" },
          },
        }}
      >
        <Box          
          p={theme.spacing(4)}          
          borderRadius="1rem"
          backgroundColor={theme.palette.background.alt}          
        >
          <Form />
        </Box>
      </Box>      
    </Box>
  );
};

export default LoginPage;
